import { Box } from "@chakra-ui/react";

const Phrase: React.FC<React.PropsWithChildren<Record<string, any>>> = ({ children }) => (
  <Box as="p" background="purple.550" padding=".5rem 1rem" fontSize="1rem" color="white" borderRadius=".5rem">
    {children}
  </Box>
);

export default Phrase;
